import { useTranslate, T } from '@tolgee/react';

export interface RuleStatusBarProps {
  /** 已启用数量 */
  enabledCount: number;
  /** 总数量 */
  totalCount: number;
}

function RuleStatusBar(props: RuleStatusBarProps) {
  const { enabledCount, totalCount } = props;
  const { t } = useTranslate();

  return (
    <div data-sid="rsb-root-01" className="flex items-center justify-between px-4 py-3 bg-gray-50">
      <span
        data-sid="rsb-hint-02"
        className="text-[13px] text-gray-400 font-normal leading-[18px] tracking-normal text-left"
      >
        <T
          keyName="scene.aiAgentConfig.scenarioDetail.hint.branchMatchOrder"
          params={{
            x: (
              <span className="font-bold">
                {t('scene.aiAgentConfig.scenarioDetail.rule.matchThenStop')}
              </span>
            ),
          }}
        />
      </span>
      <span
        data-sid="rsb-stats-03"
        className="font-normal text-xs text-[#84868C] text-right leading-[18px]"
      >
        {t('scene.aiAgentConfig.scenarioList.description.enabledBranchCount', {
          enableCount: enabledCount,
          allCount: totalCount,
        })}
      </span>
    </div>
  );
}

export default RuleStatusBar;
